/**
 * Utility functions for formatting match dates and times consistently across the app
 */

/**
 * Format a match date and time in full format (long weekday, long month)
 * @param date - Date string (ISO format) or Date object
 * @returns Object with separate date and time strings
 */
export function formatMatchDateFull(date: string | Date): { date: string; time: string } {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const dateStr = dateObj.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  const timeStr = dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit'
  });
  
  return {
    date: dateStr,
    time: timeStr
  };
}

/**
 * Format a match date and time in compact format (short weekday, short month)
 * @param date - Date string (ISO format) or Date object
 * @param includeYear - Whether to include the year (default: false)
 * @returns Object with separate date and time strings
 */
export function formatMatchDateCompact(date: string | Date, includeYear: boolean = false): { date: string; time: string } {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const dateOptions: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  };
  
  if (includeYear) {
    dateOptions.year = 'numeric';
  }
  
  const dateStr = dateObj.toLocaleDateString('en-US', dateOptions);
  
  const timeStr = dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit'
  });
  
  return {
    date: dateStr,
    time: timeStr
  };
}

